import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";


export class ShowContentFactoryFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    parentGroup: FilterGroup;
    isFirst: boolean;
    isLast: boolean;

    constructor(parentGroup: FilterGroup, isFirst: boolean, isLast: boolean, nbColumns: number) {
        this.id = 'showContentFactory';
        this.name = 'Content Factory';
        this.type = 'showContentFactory';
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.nbColums = nbColumns;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = '';
        
        if (this.isFirst) {
            html += '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">'
        }
        html += `
        <div class="${FilterGroup.getColumParam(this.nbColums!)}" style="width: fit-content;height: fit-content;">
            <input id="contentFactoryCheckbox" class="btn-default" type="checkbox">
            ${this.name}
        </div>
        `;
        if (this.isLast) {
            html += '</div>';
        }
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#contentFactoryCheckbox').prop('checked', FilterGroup.filters.showContentFactory);
            this.controller.addEventListener('change', () => {
                let val = $('#contentFactoryCheckbox').is(':checked');
                FilterGroup.filters.showContentFactory = val;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'contentFactoryCheckbox');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.showContentFactory === true) {
                return('&q.pipeline.quality.eq=high');
            }
        }
        return("");
    }

    destroy(): void {
        this.controller.destroy();
    }
}